import { render, staticRenderFns } from "./invoicesList.vue?vue&type=template&id=e636e07a"
import script from "./invoicesList.vue?vue&type=script&lang=js"
export * from "./invoicesList.vue?vue&type=script&lang=js"
import style0 from "./invoicesList.vue?vue&type=style&index=0&id=e636e07a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports